/**
 * Generate the tailwind shades with
 * @see https://www.tailwindshades.com/
 */

module.exports = {
  container: {
    center: true,
    padding: "15px",
  },
  extend: {
    screens: {
      sm: "640px",
      md: "768px",
      lg: "1024px",
      xl: "1330px",
      "2xl": "1330px",
      "3xl": "1550px",
      "lg-down": {
        max: "1329px",
      },
      "md-down": {
        max: "1023px",
      },
      "sm-down": {
        max: "767px",
      },
      "sm-only": {
        max: "669px",
      },
    },
    fontFamily: {
      sans: ["Poppins", "sans-serif"],
      heading: ["Poppins", "sans-serif"],
      daysone: ["Poppins", "sans-serif"],
      catamaran: ["Poppins", "sans-serif"],
    },
    colors: {
      transparent: "transparent",
      current: "currentColor",
      "body-background": "#ffffff",
      "body-text": "#333333",
      black: {
        DEFAULT: "#000000",
      },
      white: {
        DEFAULT: "#ffffff",
      },
      lightgrey: {
        DEFAULT: "#F9F9F9",
      },
      primary: {
        DEFAULT: "#00335A",
        hover: "#005696",
        50: "#eef8ff",
        100: "#dcf2ff",
        900: "#00497a",
      },
      secondary: {
        DEFAULT: "#005696",
        hover: "#00335A",
        50: "#eef8ff",
        100: "#deefff",
      },
      accent: {
        DEFAULT: "#00a2c4",
        light: "#00a2c4",
        hover: "#005696",
        50: "#ebffff",
        100: "#cdfdff",
        200: "#a1f8ff",
      },
    },
    lineHeight: {
      heading: "1.27",
    },
    margin: {
      container: "15px",
    },
    borderRadius: {
      button: "23px",
    },
    boxShadow: {
      card: "0 10px 20px 0px rgba(0, 0, 0, 0.07)",
      callout: "0 10px 20px 0px rgba(0, 0, 0, 0.15)",
    },
  },
};
